import BodyTypography from '../../../../Common/BodyTypography';
import GridRowNode from './GridRowNode';

interface GridRowItemProps {
    title: string;
    value: string;
}
function GridRowItem({ title, value }: GridRowItemProps) {
    return (
        <GridRowNode
            title={<BodyTypography>{title}:</BodyTypography>}
            node={<BodyTypography>{value}</BodyTypography>}
        />
    );
}
export default GridRowItem;
